import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Switch, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './style.scss';

const propTypes = {
    onDisable: PropTypes.func.isRequired,
    provider: PropTypes.object.isRequired,
    toggled: PropTypes.bool,
};

class DisableIntegration extends Component {
    onDisable = (isInputChecked) => {
        const { onDisable } = this.props;
        onDisable && onDisable(isInputChecked);
    };

    render() {
        const { provider, toggled } = this.props;
        const title = getLiteral('title_welcome_integration').replace(
            '%@',
            getLiteral(provider.data.NameLabel),
        );

        return (
            <div className="integrations-disable-component-container">
                <div className="integration-disable-desc-content">
                    <Text
                        as="div"
                        className="inside-disable-component-title"
                        medium
                        type="subtitle1"
                    >
                        {title}
                    </Text>
                    <Text as="div" className="inside-disable-component-desc" type="body">
                        {getLiteral(provider.data.Description_Long)}
                    </Text>
                </div>
                <div className="integration-disable-toggle-container">
                    <Text as="span" className="integration-disable-toggle-label" medium type="body">
                        {getLiteral('label_active')}
                    </Text>
                    <Switch checked={toggled} onChange={this.onDisable} size="medium" />
                </div>
            </div>
        );
    }
}

DisableIntegration.propTypes = propTypes;

export default DisableIntegration;
